import { getDecodedConsulData } from '@shared/lib/consul'
import { CommissionDataByServiceIdType } from '../model/denomination.types'

export const fetchCommissionDataForServices = async () => {
  const data = await getDecodedConsulData<CommissionDataByServiceIdType>('/commission/value')

  return data
}
